import Swal from "sweetalert2";
import Forword from './Forword/Forword.vue';
import HelperMixin from '../../../Shared/HelperMixin.vue'
export default {
    name: "AddUser",
    mixins: [HelperMixin],
    async created() {
        await this.CheckLoginStatus();
        await this.GetAllOffices(1);

        this.GetInfo();
    },
    components: {
        'Forword': Forword,
    },
    
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,

            Info: [],

            OfficeId: '',
            Search: '',
            From: '',
            To: '',
            SelectedItem: '',


            ruleForm: {
                Id: 0,
                Type: 1,
                OfficeId: '',
                ReferenceNumber: '',
                MessageDate: '',
                Subject: '',
                Content: '',
                Notes: '',

                Attachments: [],

                ImageName: '',
                ImageType: '',
                fileBase64: '',

            },
            rules: {
                OfficeId: this.$helper.RequiredInput(' الجهة'),
                ReferenceNumber: this.$helper.RequiredInput('الرقم الإشاري '),
                MessageDate: this.$helper.RequiredInput('تاريخ الرسالة'),
                Subject: this.$helper.RequiredInput('الموضوع '),
                Content: this.$helper.RequiredInput('المحتوي '),
            },

            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,


        };
    },

    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (this.From)
                this.From = this.ChangeDate(this.From);

            if (this.To)
                this.To = this.ChangeDate(this.To);

            this.$blockUI.Start();
            this.$http
                .GetInboxAdmin(this.pageNo, this.pageSize, this.OfficeId, this.Search, this.From,this.To,1)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.state = 1;
            this.ruleForm.Id = item.id;
            this.ruleForm.OfficeId = item.fromId;
            this.ruleForm.ReferenceNumber = item.referenceNumber;
            this.ruleForm.MessageDate = item.messageDate;
            this.ruleForm.Subject = item.subject;
            this.ruleForm.Content = item.content;
            this.ruleForm.Notes = item.notes;
            this.ruleForm.Attachments = item.messageAttachments;
            this.Seen(item.id);
        },

        Seen(Id) {
            this.$http.Seen(Id)
                .then(() => {
                    this.GetInfo(this.pageNo);
                })
        },

        OpenForwordPage(item) {
            this.SelectedItem = item;
            this.state = 2;
            if (!item.isSeen)
                this.Seen(item.id);
        },

        //Image Handle
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        handleDownload(file) {
            const link = document.createElement('a');
            link.href = file.url;
            link.target = '_blank';
            link.download = '';
            link.click();
        },

        handleRemove(Id) {
            Swal.fire({
                title: "هـل انت متأكد من عملية حذف المرفق ؟",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `تأكيد العملية`,
                denyButtonText: `الغاء العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteMessageAttachment(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                            this.AddViewDilogRequest = false;
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                        });
                    return;
                }
            });
        },

        //Support Info
        Back() {
            this.state = 0;
            this.SelectedItem = '';
            this.GetInfo(this.pageNo);
        },

    },
};
